// Snapshot window.Pusher before pusher-js's web build overwrites it on import,
// so callers can restore Chatlio's own Pusher afterward. See websockets.js.
export const hadPusher = typeof window !== "undefined" && "Pusher" in window;
export const priorPusher = typeof window !== "undefined" ? window.Pusher : undefined;
